import { render, staticRenderFns } from "./analysisView.vue?vue&type=template&id=4b857ada&scoped=true"
import script from "./analysisView.vue?vue&type=script&lang=js"
export * from "./analysisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b857ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b857ada')) {
      api.createRecord('4b857ada', component.options)
    } else {
      api.reload('4b857ada', component.options)
    }
    module.hot.accept("./analysisView.vue?vue&type=template&id=4b857ada&scoped=true", function () {
      api.rerender('4b857ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/analysisView.vue"
export default component.exports